import {ui} from "./utils/ui";
import {deleteFiles} from "./features/deleteFiles";


export default () => {
    if (ui.pictures) deleteFiles(ui.pictures);
    if (ui.movies) deleteFiles(ui.movies);
}
